import { render } from "./DealerAccordonItem.vue?vue&type=template&id=6a6a02d8"
import script from "./DealerAccordonItem.vue?vue&type=script&lang=js"
export * from "./DealerAccordonItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__